export const GREEN_ZONE_PERCENTAGE = 0.1; // 10% on each side (20% overall)
export const MAX_RATE_PENNIES = 9995000; // 99,950 pennies (£99,950)

const getRoundingIncrement = (value: number) =>
  value <= 100000 ? 1000 : value <= 200000 ? 2000 : 5000;

/**
 * Rounds a rate in pennies to a display-friendly value.
 * - Less than £1000: round to nearest £10
 * - Less than £2000: round to nearest £20
 * - More than £2000: round to nearest £50
 */
export const roundDisplayRate = (rate: number): number => {
  const increment = getRoundingIncrement(rate);
  return Math.round(rate / increment) * increment;
};

export const calculateRateCardMetrics = (referenceValue: number) => {
  const initialIncrement = getRoundingIncrement(referenceValue);

  // 1. Round reference up to nearest increment
  const center =
    Math.round(referenceValue / initialIncrement) * initialIncrement;

  const increment = getRoundingIncrement(center);

  // 2. 10% upper threshold
  const upperBoundRaw = center * (1 + GREEN_ZONE_PERCENTAGE);

  // 3. Round upper threshold to nearest increment, capped at maximum value
  const upperBound = Math.min(
    Math.round(upperBoundRaw / increment) * increment,
    MAX_RATE_PENNIES,
  );

  // 5. Calculate symmetric range
  // Ensure range is at least one increment to avoid 0 width
  const rangeRadius = Math.max(upperBound - center, increment);
  const lowerBound = Math.max(center - rangeRadius, 0);

  return { center, lowerBound, upperBound, rangeRadius };
};
